<div class="form-box">
  <div class="step-section">
    <div class="step-title">
      <p-skeleton shape="circle" size="32px" />
      <p-skeleton width="14rem" height="1rem" />
    </div>
    <div class="step-fields mt-4">
      <div class="step-field-skeleton">
        <p-skeleton width="8rem" height="0.75rem" />
        <p-skeleton height="44px" borderRadius="1rem" />
      </div>
      <div class="step-field-skeleton">
        <p-skeleton width="7rem" height="0.75rem" />
        <p-skeleton height="44px" borderRadius="1rem" />
      </div>
    </div>
  </div>
  <div class="bulk-upload-container">
    <div class="upload-box">
      <div class="step-title">
        <p-skeleton shape="circle" size="32px" />
        <p-skeleton width="11rem" height="1rem" />
      </div>
      <p-skeleton height="110px" borderRadius="0.75rem" />
      <p-skeleton height="5rem" borderRadius="0.75rem" />
      <p-skeleton width="160px" height="38px" borderRadius="1rem" />
    </div>
    <div class="upload-box">
      <div class="step-title">
        <p-skeleton shape="circle" size="32px" />
        <p-skeleton width="9rem" height="1rem" />
      </div>
      <p-skeleton height="170px" borderRadius="0.75rem" />
      <p-skeleton width="160px" height="38px" borderRadius="1rem" />
    </div>
  </div>
</div>
